import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/pages/Login'], resolve)
    },
    {
      path: '/login',
      component: resolve => require(['@/pages/Login'], resolve)
    },
    {
      path: '/spread/give',
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => require(['@/pages/spread/Give'], resolve)
    },
    {
      path: '/console',
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => require(['@/pages/Console'], resolve),
      children: [
        {
          path: 'content/opus/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/content/OpusList'], resolve)
        },
        {
          path: 'content/brochure/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/content/BrochureList'], resolve)
        },
        {
          path: 'product/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/product/ProductList'], resolve)
        },
        {
          path: 'template/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/template/TemplateList'], resolve)
        },
        {
          path: 'user/dealer/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/user/DealerList'], resolve)
        },
        {
          path: 'user/personal/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/user/PersonalList'], resolve)
        },
        {
          path: 'user/business/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/user/BusinessList'], resolve)
        },
        {
          path: 'trade/order/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/trade/OrderList'], resolve)
        },
        {
          path: 'trade/order/list2',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/trade/OrderListNew'], resolve)
        },
        {
          path: 'trade/order/add',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/trade/OrderAddOpus'], resolve)
        },
        {
          path: 'data/cobra/list',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/data/CobraList'], resolve)
        },
        {
          path: 'home/dashboard',
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => require(['@/pages/home/Dashboard'], resolve)
        }
      ]
    }
    // ,
    // {
    //   path: '*', // 此处需特别注意置于最底部
    //   redirect: '/'
    // }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (sessionStorage.getItem('token')) { // 通过vuex state获取当前的token是否存在
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/utils/router.js